module.exports = __webpack_public_path__ + "img/rond-bleu.1b181896.png";